import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import {
  getNativeAppLink,
  androidOsName,
  iphoneOsName,
  shouldShowNativeAppBanner,
} from 'common/util/isUserAgentMobileApp';
import branch from 'client/core/branch';
import UserActions from 'client/actions/User';

@withRouter
@branch({
  userAgent: ['analytics', 'userAgent'],
  currentUser: ['currentUser'],
})
class SrNativeAppBanner extends Component {
  static propTypes = {
    userAgent: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  _onNativeAppBannerGetButtonClick = () => {
    const { dispatch, userAgent } = this.props;
    dispatch(UserActions.updateSettings, {
      nativeBannerAppClosed: true,
    });

    const nativeAppLink = getNativeAppLink(userAgent);
    global.location = nativeAppLink;
  }

  _onNativeAppBannerExitButtonClick = () => {
    this.props.dispatch(UserActions.updateSettings, {
      nativeBannerAppClosed: true,
    });
  }

  render() {
    const {
      userAgent,
      currentUser,
      location,
    } = this.props;

    const showNativeAppBanner = shouldShowNativeAppBanner({
      userAgent,
      currentUser,
      location,
    });

    if (!showNativeAppBanner) {
      return null;
    }

    const nativeAppBannerCtaText = userAgent.osName === androidOsName
      ? 'view'
      : 'get';

    return (
      <div className='nativeAppBanner'>
        <div className='x-close' onClick={this._onNativeAppBannerExitButtonClick} />
        <div className='appIcon' />
        <div className='textContainer'>
          <span className='headline weight-medium'>Sunroom: Houses & Apartments</span>
          <span className='subhead'>Sunroom Rentals</span>
          <div className='rating'>
            <div className='star' />
            <div className='star' />
            <div className='star' />
            <div className='star' />
            <div className='star' />
          </div>
          {userAgent.osName === androidOsName && (
            <span className='getOnAppstore'>Add to Home screen</span>
          )}
          {userAgent.osName === iphoneOsName && (
            <span className='getOnAppstore'>GET — On the App Store</span>
          )}
        </div>
        <span onClick={this._onNativeAppBannerGetButtonClick} className='getLink blue-bright'>
          {nativeAppBannerCtaText}
        </span>
      </div>
    );
  }
}

SrNativeAppBanner.displayName = 'SrNativeAppBanner';

export default SrNativeAppBanner;
